import { createSlice } from '@reduxjs/toolkit';

const homeCategoriesSlice = createSlice({
    name: 'homeCategories',
    initialState: { data: [] },
    reducers: {
        addHomeCategories: (state, action) => { state.data = action.payload; },
    },
});
export const { addHomeCategories } = homeCategoriesSlice.actions;
export default homeCategoriesSlice.reducer;
